/** Keyboard capture rules for the remote-desktop canvas (pages/DesktopSession). */

// F42: while the remote canvas has focus every key (Tab and Escape included) goes
// to the remote host, so there must be a way back out that the remote never needs.
// Ctrl+Alt+Shift (all three held, no other key) releases focus to the toolbar.
export const RELEASE_HINT = 'Ctrl+Alt+Shift';
export function isReleaseCombo(e: Pick<KeyboardEvent, 'ctrlKey' | 'altKey' | 'shiftKey' | 'key'>): boolean {
    return e.ctrlKey && e.altKey && e.shiftKey && (e.key === 'Control' || e.key === 'Alt' || e.key === 'Shift');
}
